var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-cost-unit-workshop-invoice-positions" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "8" } }, [
                    _c("h2", [_vm._v("Werkstattrechnung")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { cols: "4" },
                    },
                    [
                      _c("b-button", { on: { click: _vm.toggleCollapse } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.collapseToggleLabel) +
                            "\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.collapsed,
                      expression: "!collapsed",
                    },
                  ],
                },
                [
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "AW pro Stunde",
                          property: "workUnitsPerHour",
                          type: "number",
                        },
                        on: { change: _vm.onChangeWorkUnitsPerHour },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Karosserie")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "AW",
                          property: "bodyWorkWorkUnits",
                          type: "number",
                        },
                        on: { change: _vm.onChangeBodyWork },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Stundensatz",
                          property: "bodyWorkHourlyRate",
                          type: "currency",
                        },
                        on: {
                          change: _vm.onChangeBodyWork,
                          input: _vm.onChangeBodyWork,
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Summe",
                          property: "bodyWorkTotal",
                          type: "currency",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Lackierung")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "AW",
                          property: "lacquerWorkUnits",
                          type: "number",
                        },
                        on: { change: _vm.onChangeLacquer },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Stundensatz",
                          property: "lacquerHourlyRate",
                          type: "currency",
                        },
                        on: { change: _vm.onChangeLacquer },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Summe",
                          property: "lacquerTotal",
                          type: "currency",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Sonstiges")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Lackmaterial",
                          property: "lacquerMaterial",
                          type: "currency",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Ersatzteile Summe",
                          property: "sparePartsTotal",
                          type: "currency",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Nebenkosten",
                          property: "additionalCosts",
                          type: "currency",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }